// src/stores/cart/getters.js
import { OrderType } from '../../types/order'
import { PriceUtils } from '@/utils/price'
import { useTaxTypesStore } from '../tax-types'

/**
 * @typedef {Object} CartState
 * @property {Array<{ id: string, price: number, quantity: number }>} items
 * @property {string} discountType
 * @property {number} discountValue
 * @property {string|null} type
 * @property {string|null} editingInvoiceId
 * @property {string|null} editingInvoiceStatus
 * @property {string|null} holdInvoiceId
 * @property {string|null} availableTaxTypes
 */

export const getters = {
  /** @param {CartState} state */
  subtotal: (state) => {
    return state.items.reduce((sum, item) => {
      const itemPrice = PriceUtils.normalizePrice(item.price)
      const itemTotal = itemPrice * item.quantity
      return sum + itemTotal
    }, 0)
  },

  /** @param {CartState} state */
  discountAmount: (state) => {
    if (state.discountType === '%') {
      return (state.subtotal * state.discountValue) / 100;
    }
    return state.discountValue;
  },

  getters: {
    customerNotes: (state) => state.notes // Solo devuelve la nota
  },

   /** @param {CartState} state */
  // getNotes: (state) => {
  //   if (!state.notes) return "";
  
  //   if (typeof state.notes === "string") {
  //     try {
  //       const parsedNotes = JSON.parse(state.notes);
  //       return parsedNotes.customerNotes || "";
  //     } catch {
  //       return state.notes;
  //     }
  //   }
  
  //   return state.notes.customerNotes || "";
  // },  
  
  /** @param {CartState} state */
  taxableAmount: (state) => {
    const subtotal = state.items.reduce((sum, item) => {
      const itemPrice = PriceUtils.normalizePrice(item.price)
      return sum + (itemPrice * item.quantity)
    }, 0)
    
    const discount = state.discountType === '%' 
      ? Math.round(subtotal * (Number(state.discountValue) / 100))
      : (() => {
          const discountValue = Number(state.discountValue) || 0
          if (Number.isInteger(discountValue) && discountValue > 0 && discountValue < 100) {
            return discountValue * 100
          }
          return PriceUtils.normalizePrice(state.discountValue)
        })()
    
    
    return subtotal - discount
  },

  /** @param {CartState} state */
  taxAmount: (state) => {
    if (!state.availableTaxTypes || state.availableTaxTypes.length === 0) {
      return 0 
    }
    const taxableAmount = state.items.reduce((sum, item) => {
      const itemPrice = PriceUtils.normalizePrice(item.price)
      return sum + (itemPrice * item.quantity)
    }, 0) - getters.discountAmount(state)
  
    return state.availableTaxTypes.reduce((sum, tax) => {
      return sum + (taxableAmount * (tax.percent / 100))
    }, 0)
  },

  /** @param {CartState} state */
  total: (state) => {
    const subtotal = state.items.reduce((sum, item) => {
      const itemPrice = PriceUtils.normalizePrice(item.price)
      return sum + (itemPrice * item.quantity)
    }, 0)
    
    const discount = getters.discountAmount(state)
    const taxableAmount = subtotal - discount
    const taxAmount = getters.taxAmount(state)

    return Math.round(taxableAmount + taxAmount)
  },

  /** @param {CartState} state */
  itemCount: (state) => {
    return state.items.reduce((sum, item) => sum + item.quantity, 0)
  },

  /** @param {CartState} state */
  isEmpty: (state) => {
    return state.items.length === 0
  },

  /** @param {CartState} state */
  isHoldOrder: (state) => {
    return state.holdInvoiceId !== null
  },

  /** @param {CartState} state */
  orderType: (state) => {
    return state.type || null
  },

  /** @param {CartState} state */
  isValidOrderType: (state) => {
    if (!state.type) return false
    /** @type {string[]} */
    const validTypes = [
      'DINE IN',
      'TO-GO',
      'DELIVERY',
      'PICKUP'
    ]
    return validTypes.includes(state.type)
  },

  /** @param {CartState} state */
 
  isEditingInvoice: (state) => {
    return state.editingInvoiceId !== null
  },

  /** @param {CartState} state */
  canUpdateInvoice: (state) => {
    return state.editingInvoiceId !== null && 
           state.editingInvoiceStatus && ['DRAFT', 'SENT'].includes(state.editingInvoiceStatus)
  }
}